// Dashboard App usage translations (pt-BR), loaded into dashboard.usage by ./pt-BR.js
module.exports = {
  label: "Uso da App",
  engagement: require('./usage/pt-BR.engagement.js'),
  platforms: require('./usage/pt-BR.platforms.js'),
};
